import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';

interface DialogDept { id: string; name?: string; }
interface DialogFile { key: string; name: string; departmentIds: string[]; }

@Component({
  selector: 'app-upload-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatExpansionModule],
  templateUrl: './bulk-upload-confirmation-dialog.component.html',
  styleUrl: './bulk-upload-confirmation-dialog.component.css'
})
export class UploadConfirmationDialogComponent {
  // Per-file selected department ids (only used in perFileDepartments mode)
  fileDeptSelections: Record<string, Set<string>> = {};

  constructor(
    private readonly dialogRef: MatDialogRef<UploadConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      fileNames: string[];
      departments?: string[];
      isBulk?: boolean;
      warningOnly?: boolean;
      title?: string;
      message?: string;
      perFileDepartments?: boolean;
      availableDepartments?: DialogDept[];
      files?: DialogFile[];
    }
  ) {
    if (this.data.perFileDepartments) {
      for (const f of this.data.files || []) {
        this.fileDeptSelections[f.key] = new Set<string>(f.departmentIds || []);
      }
    }
  }

  isDeptChecked(fileKey: string, deptId: string): boolean {
    return this.fileDeptSelections[fileKey]?.has(deptId) ?? false;
  }

  toggleDept(fileKey: string, deptId: string): void {
    const set = this.fileDeptSelections[fileKey] ?? new Set<string>();
    if (set.has(deptId)) {
      set.delete(deptId);
    } else {
      set.add(deptId);
    }
    this.fileDeptSelections[fileKey] = set;
  }

  selectedCount(fileKey: string): number {
    return this.fileDeptSelections[fileKey]?.size ?? 0;
  }

  get canConfirm(): boolean {
    return (this.data.files || []).some(f => this.selectedCount(f.key) > 0);
  }

  confirmPerFile(): void {
    const selections = (this.data.files || [])
      .map(f => ({ key: f.key, name: f.name, departmentIds: Array.from(this.fileDeptSelections[f.key] || []) }))
      .filter(s => s.departmentIds.length > 0);
    this.dialogRef.close({ confirmed: true, selections });
  }

  close(result: 'yes' | 'no'): void {
    this.dialogRef.close(result);
  }
}

